
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/subprocessor-policy",
      function () {
        return require("private-next-pages/subprocessor-policy.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/subprocessor-policy"])
      });
    }
  